

export const AnimationsPage = () => {

  return(<div className="css-page">
    <h2>Animations</h2>
  </div>)
}